import $ from 'jquery';
import { removeProvenanceFromUrl } from '../functions';

let CryptoJS = require("crypto-js");
$( document ).ready(function() {
    removeProvenanceFromUrl();

    let query = lsi.getQueryObject();
    let intervalReference;
    let display;
    const NEXT_MOVIE_INTERVAL_IN_MS = 10000;
    const ONE_SECOND_IN_MS = 1000;
    const QUARTER_OF_A_SECOND_IN_MS = ONE_SECOND_IN_MS / 4;

    $.pageChange(function() {
        $("body").addClass("stretch");

        let playerOptions = jwPlayerOptions();
        let player = jwplayer("movie-container").setup(JSON.parse(playerOptions));
        let time;
        let state = "IDLE";
        let lastPlayStart = null;
        let lastBufferStart = null;
        let bufferTime = 0.0;
        let playTime = 0.0;
        let watchSeconds = 0;
        let position = 0;
        let previousPosition = 0;

        $('#skip-intro a').on('click', function() {
            jwplayer("movie-container").seek( lsi.textToTime(window.jwpo.skipIntroAt) );
        });

        $( '.lang-select' ).on('click', function () {
            toggleSelected(this, '.lang-selected', '.lang-select');
        });

        $( '.sub-select' ).on('click', function () {
            toggleSelected(this, '.sub-selected', '.sub-select');
            setSubtitleTrack( $(this).data().label );
        });

        player.on("ready", function(e) {
            $('.jw-preview').css('background-image', 'url(' + preparedUrl(window.jwpo.path.cover) + ')');
            time = window.jwpo.resumeTime && window.jwpo.resumeTime != 0 ? lsi.textToTime(window.jwpo.resumeTime) : 0;
            if (query["delay_start"]) {
                display = $('#countdown-time > a');
                if (window.jwpo.currentSequence < 3) {
                    startTimer(window.jwpo.delaySeconds, display);
                } else {
                    display.text("Press here to play " + preparedString(window.jwpo.title));
                }
            }

            moveCustomElements();

            let current_captions = player.getCurrentCaptions();
            player.setCurrentCaptions(current_captions);

            let img = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" role="img" viewBox="0 0 24 24" width="24" height="24" data-icon="SubtitlesStandard" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 3C1 2.44772 1.44772 2 2 2H22C22.5523 2 23 2.44772 23 3V17C23 17.5523 22.5523 18 22 18H19V21C19 21.3688 18.797 21.7077 18.4719 21.8817C18.1467 22.0557 17.7522 22.0366 17.4453 21.8321L11.6972 18H2C1.44772 18 1 17.5523 1 17V3ZM3 4V16H12H12.3028L12.5547 16.1679L17 19.1315V17V16H18H21V4H3ZM10 9L5 9V7L10 7V9ZM19 11H14V13H19V11ZM12 13L5 13V11L12 11V13ZM19 7H12V9H19V7Z" fill="currentColor"></path></svg>`;
            player.addButton(img, 'Available Languages', function () {
                let $langModal = $('#langModal');
                if ( $langModal ) {
                    $langModal.modal('show');
                    let backdrop = $langModal.data('bs.modal')._backdrop
                    $(backdrop).css('background-color','black');
                    $(backdrop).css('opacity','0.0');
                }

            }, 'audio-lang-btn', 'jw-icon jw-icon-inline jw-button-color jw-reset jw-settings-submenu-button jw-off');
        });

        function moveCustomElements() {
            $(".show-on-fullscreen").appendTo("#movie-container");
        }

        function toggleSelected(that, checkmark, label) {
            $(checkmark).removeClass('opacity-0-0').removeClass('opacity-0-8').addClass('opacity-0-0');
            $(label).removeClass('opacity-0-6').removeClass('opacity-0-8').addClass('opacity-0-6');
            $(that).parent().find(checkmark).removeClass('opacity-0-0').addClass('opacity-0-8');
            $(that).removeClass('opacity-0-6').addClass('opacity-0-8');
        }

        function setSubtitleTrack(label) {
            let captions_list = player.getCaptionsList();
            let subtitle_track_index = captions_list.findIndex(function(captions) {
                return captions.label === label;
            });

            if ( subtitle_track_index ) {
                player.setCurrentCaptions(subtitle_track_index);
            } else {
                player.setCurrentCaptions(0);
            }
        }

// ON PLAY
// WHEN autostart: true, seek(time) DOES NOT WORK WITHIN onReady FUNCTION
        player.on("play", function (e) {
            updateTimesAndSetState("PLAYING");

            if (!(display === undefined)) {
                display.text("");
            }
            if (!(intervalReference === undefined)) {
                clearInterval(intervalReference);
            }
            if (time && time > 0 && !query["delay_start"]) {
                jwplayer("movie-container").seek(time);
                time = 0;
            }
        });

// ON PAUSE
        player.on("pause", function (e) {
            updateTimesAndSetState("PAUSED");
        });


// ON COMPLETE
        player.on("complete", function () {
            updateTimesAndSetState("COMPLETED");
            if (window.jwpo.regularMovie) {
                setTimeout(function () {
                    window.open(preparedUrl(window.jwpo.path.complete.regular), "_self");
                }, (NEXT_MOVIE_INTERVAL_IN_MS / 2));
            } else if (window.jwpo.liveEvent) {
                window.open(preparedUrl(window.jwpo.path.complete.live), "_self");
            } else if (window.jwpo.public) {
                window.open(preparedUrl(window.jwpo.path.complete.public), "_self");
            } else {
                $('#movie-container').hide();
                setTimeout(function () {
                    //window.open( preparedUrl(window.jwpo.path.complete.other),"_self");
                    history.back();
                }, (NEXT_MOVIE_INTERVAL_IN_MS / 10 / 2));
            }
        });


// ON BUFFER
        player.on("buffer", function (e) {
            updateTimesAndSetState("BUFFERING");
        });

// ON ERROR
        player.on("error", function (e) {
            updateTimesAndSetState("ERROR");
        });

        $(window).on("unload", function (e) {
            updateTimesAndSetState("UNLOADED");

            finishMovie();
        });

        function postCheckin() {
            let post_data = {
                watch_seconds: watchSeconds,
                resume_time : String( Math.floor( jwplayer("movie-container").getPosition() ) ),
                tracking_id: preparedString(window.jwpo.trackingId),
                device: 'browser',
                debug: true
            };

            if (window.jwpo.token && window.jwpo.token !== "") {
                post_data.token = preparedString(window.jwpo.token);
            }

            $.ajax({
                url: preparedUrl(window.jwpo.path.check_in),
                type: 'POST',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
                },
                data: post_data,
                success: function(response) {
                    //console.log(response);
                }
            }).fail(function(data) {
                let response = data.responseJSON;
                if (response) {
                    //console.log(response);
                    if(!response.success && response.message && response.message == 'tracking id is invalid') {
                        // Obtain a new tracking id by reloading the player on current player position
                        try {
                            bufferTime = ( bufferTime && bufferTime > 0 ? round(bufferTime, 8) : 0.0 );
                        }catch (e) {
                            console.error("couldn't round buffer time");
                        }

                        $.ajax({
                            url: preparedUrl(window.jwpo.path.finish),
                            beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
                            data: {
                                "resume_time" : Math.floor(jwplayer("movie-container").getPosition()),
                                "buffer_time" : bufferTime,
                                "play_time" : playTime
                            },
                            type: "post"
                        });

                        window.location.href = preparedUrl(window.jwpo.path.play);
                    }
                } else {
                    console.error('check in failed!');
                }
            });

            watchSeconds = 0;
        }

        watchSeconds = 0;
        position = 0;

        let playNextTimeout;
        let playingCredits = false;
        let firstCheckIn = false;

//seconds watched to be sent
        player.on("time", function(e) {
            previousPosition = position;
            position = parseInt(e.position);

            if (position != previousPosition) {
                watchSeconds += 1;

                if(!firstCheckIn) {
                    postCheckin();
                    firstCheckIn = true;
                }

                if (watchSeconds >= 10) {
                    postCheckin();
                }

                let $skip_intro = $('#skip-intro');
                if ($skip_intro &&  window.jwpo.skipIntroAt > 0 && position < window.jwpo.skipIntroAt) {
                    $skip_intro.removeClass('d-none');
                    $skip_intro.addClass('d-block');
                } else {
                    $skip_intro.removeClass('d-block');
                    $skip_intro.addClass('d-none');
                }

                if (position > window.jwpo.skipCreditsAt) {
                    crediting();
                } else {
                    notCrediting();
                }
            }
        });

        function crediting() {
            if (playingCredits || window.jwpo.noNext) {
                return;
            }
            playingCredits = true;
            showUpNext();

            playNextTimeout = setTimeout(function() {
                if (window.end_of_movie && window.end_of_movie.object[0]) {
                    window.end_of_movie.object.modal('hide');
                    setTimeout(function() {
                        window.location.href = preparedUrl(window.jwpo.path.playNext);
                    }, QUARTER_OF_A_SECOND_IN_MS );
                }
            }, NEXT_MOVIE_INTERVAL_IN_MS);
        }

        function notCrediting() {
            if (window.jwpo.noNext) {
                return;
            }

            if (playingCredits) {
                playingCredits = false;
                hideUpNext();
            }
        }

        $("#watch-credits").click(function() {
            hideUpNext();
        });

        $(".hide-up-next").click(function() {
            hideUpNext();
        });

        $(".quiz-game-start").click(function() {
            hideUpNext();
            player.pause();
        });

        $(".back-to-detail").click(function() {
            window.location.href = preparedUrl(window.jwpo.path.back);
        });

        function showUpNext() {
            player.setFullscreen(false);

            if (window.end_of_movie && window.end_of_movie.object[0] && window.end_of_movie.modal_options) {
                window.end_of_movie.object.modal(window.end_of_movie.modal_options);
            }

            $(".progress").css("width", "0%");
            $('.progress').animate(
                { width: '100%' },
                {
                    duration: NEXT_MOVIE_INTERVAL_IN_MS,
                    easing: "linear"
                }
            );

            endOfMovieCountdown(8, "next-movie-countdown");
        }

        function endOfMovieCountdown(countdown_in_seconds, element_id) {
            let showTime = () => {
                document.getElementById(element_id).innerHTML = `${countdown_in_seconds}`;
                countdown_in_seconds--;

                timer = setTimeout(showTime, ONE_SECOND_IN_MS);
                if (countdown_in_seconds < 0) {
                    clearTimeout(timer)
                }
            };

            let timer = setTimeout(showTime, 0);
        }

        function hideUpNext() {
            clearTimeout(playNextTimeout);
            $(".progress").stop();
        }

        function updateTimesAndSetState (new_state) {
            let time = (new Date()).getTime();

            if (state == "PLAYING" && lastPlayStart != null) {
                playTime += time - lastPlayStart;
            }
            else if (state == "BUFFERING" && lastBufferStart != null) {
                bufferTime += time - lastBufferStart;
            }

            if (new_state == "PLAYING") {
                lastPlayStart = time;
            }
            else if (new_state == "BUFFERING") {
                lastBufferStart = time;
            }

            state = new_state;
        }

        function finishMovie() {
            try {
                bufferTime = ( bufferTime && bufferTime > 0 ? round(bufferTime, 8) : 0.0 );
            }catch (e) {
                console.error("couldn't round buffer time");
            }

            $.ajax({
                url: preparedUrl(window.jwpo.path.finish),
                beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
                data: {
                    "resume_time" : Math.floor(jwplayer("movie-container").getPosition()),
                    "buffer_time" : bufferTime,
                    "play_time" : playTime
                },
                type: "post"
            });
            postCheckin();
        }

        function startTimer(duration, display) {
            let timer = duration, seconds;
            intervalReference = setInterval(function () {
                seconds = parseInt(timer % 60, 10);
                seconds = seconds < 10 ? "0" + seconds : seconds;

                if(window.jwpo.currentSequence < 3) {
                    display.text("Will play " + preparedString(window.jwpo.title) + " in "+ seconds + " seconds");
                }else{
                    display.text("Press play to start " + preparedString(window.jwpo.title));
                }

                if (--timer < 0) {
                    if(window.jwpo.currentSequence < 3) {
                        if (!jwplayer("movie-container").getMute()) {
                            jwplayer().setMute( true );
                        }
                        jwplayer("movie-container").play();
                    }
                    clearInterval(intervalReference);
                    display.text("");
                    timer = duration;
                }
            }, ONE_SECOND_IN_MS);
        }

        function round(value, decimals) {
            return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
        }

        function preparedUrl(url_bytes) {
            return String.fromCharCode.apply(null, url_bytes).replace(/&amp;/g, '&');
        }

        function preparedString(str) {
            return atob(str).split("").reverse().join("");
        }

        function jwPlayerOptions () {
            let playerOptions = window.jwpo.units.flat();
            let unified_options = String.fromCharCode.apply(null, playerOptions);
            let options = atob(unified_options.split("").reverse().join(""));
            let jsonOptions = JSON.parse(options);
            let rawData = CryptoJS.enc.Base64.parse(jsonOptions.data);
            let key = CryptoJS.enc.Base64.parse(jsonOptions.key);
            let iv = CryptoJS.enc.Base64.parse(jsonOptions.iv);
            let plaintextData = CryptoJS.AES.decrypt(
                { ciphertext: rawData },
                key,
                { iv: iv }
            );

            return plaintextData.toString(CryptoJS.enc.Utf8);
        }

    });
});